import {
    GET_WIX_SITE_INFO,
    GET_WIX_SITE_INFO_ERROR,
    GET_DOMAIN_CONNECT_STATUS,
    GET_IS_SITE_PUBLISHED,
    IS_GD_SENSE_APP_ACTIVATED,
    IS_GD_UNIT_CODE_VALID,
    GET_COMP_ID,
    GET_INSTANCE_ID,
} from '../constants';

export default (state = {}, action) => {
    switch (action.type) {
        case GET_WIX_SITE_INFO:
            return {
                ...state,
                result1: action.payload
            }
        case GET_WIX_SITE_INFO_ERROR:
            return {
                ...state,
                result2: action.payload
            }
        case GET_DOMAIN_CONNECT_STATUS:
            return {
                ...state,
                isDomainConnectedStatus: action.payload
            }
        case GET_IS_SITE_PUBLISHED:
            return {
                ...state,
                isSitePublished: action.payload
            }
        case IS_GD_SENSE_APP_ACTIVATED:
            return {
                ...state,
                isAdSenseAppActivated: action.payload
            }
        case IS_GD_UNIT_CODE_VALID:
            return {
                ...state,
                adUnitCodeState: action.payload
            }
        case GET_COMP_ID:
            return {
                ...state,
                compId: action.payload
            }
        case GET_INSTANCE_ID: {
            return {
                ...state,
                instanceId: action.payload
            }
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/commonReducer.js